import React from "react";
import { Card, Skeleton } from "antd";
import { motion } from "framer-motion";

export const ShimmerMetricCard: React.FC<{ delay?: number }> = ({ delay = 0 }) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ delay }}
    >
      <Card style={{ height: "100%" }}>
        <Skeleton active paragraph={{ rows: 1 }} />
      </Card>
    </motion.div>
  );
};

export const ShimmerTableCard: React.FC<{ rows?: number }> = ({ rows = 3 }) => {
  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
      <Card>
        <Skeleton active paragraph={{ rows }} />
      </Card>
    </motion.div>
  );
};
